import { useState } from "react";
import axiosInstance from "../../../../utility/axiosInstance";

interface UseOrganizationAgreementProps {
  organizationId: string | undefined;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useOrganizationAgreement = ({
  organizationId,
  onSuccess,
  onError,
}: UseOrganizationAgreementProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const updateAgreement = async (accepted: boolean) => {
    setIsLoading(true);
    setError(null);

    try {
      await axiosInstance.put(
        `/organizations/${organizationId}/representative-agreement`,
        {
          accepted,
        }
      );

      onSuccess?.();
      return true;
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.message || "Failed to update agreement";
      setError(errorMessage);
      onError?.(err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateAgreement,
    isLoading,
    error,
  };
};
